export const FormTypes = {
    SingleResponse: 1,
    MultipleResponse: 2
}